import {
  BaseStorageItem,
  FeedItem,
  getMimeTypeFromFile,
  ServiceProvider,
  StorageFolder,
  StorageItemMetadata,
  UPLOADCAM_FOLDER_MIME,
} from '@uploadcam/common';

export class MockItem extends BaseStorageItem {
  constructor(
    public readonly id: string,
    public readonly provider: ServiceProvider,
    public readonly driveId: string | undefined,
    public readonly parentId: string | undefined,
    public readonly allowsSubfolderCreation: boolean,
    public readonly isVirtual: boolean,
    public readonly lastModified: Date | undefined,
    public readonly metadata: StorageItemMetadata,
    public readonly mime: string,
    public readonly name: string,
    public readonly size: number | undefined,
  ) {
    super();
  }

  static file(
    id: string,
    provider: ServiceProvider,
    driveId: string | undefined,
    name: string,
    parentId: string,
    metadata: StorageItemMetadata = {},
  ): MockItem {
    return new MockItem(
      id,
      provider,
      driveId,
      parentId,
      false,
      true,
      undefined,
      metadata,
      getMimeTypeFromFile(name)?.type ?? 'application/octet-stream',
      name,
      undefined,
    );
  }

  static folder(
    id: string,
    provider: ServiceProvider,
    driveId: string | undefined,
    name: string,
    allowsSubfolderCreation = true,
    metadata: StorageItemMetadata = {},
  ): MockItem {
    return new MockItem(
      id,
      provider,
      driveId,
      undefined,
      allowsSubfolderCreation,
      true,
      undefined,
      metadata,
      UPLOADCAM_FOLDER_MIME,
      name,
      undefined,
    );
  }

  static fromFeedItem(item: FeedItem): MockItem {
    return MockItem.file(
      item.fileId,
      item.provider,
      item.driveId,
      item.fileName,
      item.folderId,
      {},
    );
  }

  static fromStorageFolder(
    folder: StorageFolder,
    allowsSubfolderCreation: boolean = true,
    name?: string,
    metadata: StorageItemMetadata = {},
  ): MockItem {
    return new MockItem(
      folder.id,
      folder.provider,
      folder.driveId,
      undefined,
      allowsSubfolderCreation,
      true,
      undefined,
      metadata,
      UPLOADCAM_FOLDER_MIME,
      name ?? folder.name,
      undefined,
    );
  }

  static rootFolder(
    id: string,
    provider: ServiceProvider,
    driveId: string | undefined,
    allowsSubfolderCreation: boolean,
    metadata: StorageItemMetadata = {},
  ): MockItem {
    return this.folder(id, provider, driveId, '/', allowsSubfolderCreation, metadata);
  }
}
